export default __webpack_public_path__ + "static/media/es-im-img.b6b254c0.webp";